import { useContext } from 'react';
import Context from './RouterContext';
import matchPath from './matchPath';
import { Location, LocationState, History } from '../history';
import { match, RouteProps } from '.';

export function useHistory<S = LocationState>(): History<S> {
  return useContext(Context).history as History<S>;
}

export function useLocation<S = LocationState>(): Location<S> {
  return useContext(Context).location as Location<S>;
}

export function useParams<
  Params extends { [K in keyof Params]?: string } = {},
>(): Params {
  return useContext(Context).match.params as Params;
}

export function useRouteMatch<
  Params extends { [K in keyof Params]?: string } = {},
>(): match<Params>;
export function useRouteMatch<
  Params extends { [K in keyof Params]?: string } = {},
>(path: string | string[] | RouteProps): match<Params> | null;
export function useRouteMatch(path?: string | string[] | RouteProps) {
  const { match: contextMatch } = useContext(Context);
  const location = useLocation();
  return path ? matchPath(location.pathname, path) : contextMatch;
}
